(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["user-manual-list"] && !Shopify.designMode) return;
  try {
    
/* No additional JS; inline script above handles search */

  } catch(e) { console.error(e); }
})();
})();
